const WhyChooseUs = () => {
  const reasons = [
    {
      icon: "https://static2.givesendgo.com/vue/home/liberty.png",
      title: "We Love Freedom",
      description: "Even if we do not agree with you, we will defend your right to fundraise for the causes and people you love."
    },
    {
      icon: "https://static2.givesendgo.com/vue/home/money-bag.png",
      title: "We Love To Give Back",
      description: "Each month, GiveSendGo designates some of our operational expenses to 'Give Back' to active campaigns on our site."
    },
    {
      icon: "https://static2.givesendgo.com/vue/home/red-pray-icon.png",
      title: "We Love to Pray",
      description: "We're the only crowdfunding site with a 'Pray' button, and our prayer team will personally pray for you."
    }
  ]

  return (
    <section className="px-4 py-16 xl:px-24">
      <div className="flex flex-col">
        <h2 className="text-center text-3xl md:text-4xl font-bold text-gsg-gray-dark mb-4">
          Why Choose Us
        </h2>
        
        <div className="mx-auto mt-3 divider gradient__background w-44"></div>
        
        <div className="flex flex-col justify-between w-full text-center mx-auto mt-10 lg:mt-20 lg:flex-row max-w-6xl gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={reason.title}
              className="flex flex-col items-center max-w-xs mx-auto px-2 mt-8 lg:mt-3 basis-1/3 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img 
                className="h-14 w-14 mb-3 object-contain" 
                src={reason.icon} 
                alt={reason.title}
              />
              <h5 className="font-semibold text-center mb-2 text-xl">{reason.title}</h5>
              <p className="text-center text-gray-600">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhyChooseUs